// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoCard_root__2XJkE","title":"InfoCard_title__3mxJL","value":"InfoCard_value__2pCju"};